/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllCoupons = (state) => values(get(state, ['coupons', 'items']));

export const requestingCoupons = (state) => (get(state, ['coupons', 'requesting']));

export const errorRequestingCoupons = (state) => get(state, ['coupons', 'error']);
